<template>
  <pf-table striped compact>
    <pf-thead>
      <pf-tr>
        <pf-th>
          {{ $t('Permesso') }}
        </pf-th>
        <pf-th :title="$t('Amministratore')">
          {{ $t('Admin') }}
        </pf-th>
        <pf-th :title="$t('Amministrativi')">
          {{ $t('Amm.') }}
        </pf-th>
        <pf-th :title="$t('Commerciali')">
          {{ $t('Comm.') }}
        </pf-th>
        <pf-th :title="$t('Tecnici')">
          {{ $t('Tech.') }}
        </pf-th>
      </pf-tr>
    </pf-thead>
    <pf-tbody>
      <pf-tr v-for="grant in grants" :key="grant.name">
        <pf-td class="grant-name">
          {{ grant.name }}
        </pf-td>
        <pf-td
          v-for="(allowed, index) in grant.grant"
          :key="index"
          :data-label="index"
        >
          <template v-if="typeof allowed === 'boolean'">
            <ok-icon v-if="allowed" color="green"/>
            <xmark-icon color="red" v-else />
          </template>
          <template v-else>{{ allowed }}</template>
        </pf-td>
      </pf-tr>

      <template v-if="login.is_reseller">
        <pf-tr v-for="grant in resellerGrants" :key="grant.name">
          <pf-td class="grant-name">
            {{ grant.name }}
          </pf-td>
          <pf-td
            v-for="(allowed, index) in grant.grant"
            :key="index"
            :data-label="index"
          >
            <template v-if="typeof allowed === 'boolean'">
              <ok-icon color="green" v-if="allowed" />
              <xmark-icon color="red" v-else />
            </template>
            <template v-else>{{ allowed }}</template>
          </pf-td>
        </pf-tr>
      </template>
    </pf-tbody>
  </pf-table>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { useLoginStore } from '@/store/login';
import OkIcon from '@vue-patternfly/icons/ok-icon';
import XmarkIcon from '@vue-patternfly/icons/xmark-icon';

interface Grant {
  name: string;
  grant: {admin: boolean, amministrativi: boolean, commerciali: boolean, tecnici: boolean};
}

const login = useLoginStore();

const grants: Grant[] = [
  {
    name: _t('Gestione degli utenti'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Visualizzazione e modifica dati aziendali'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Visualizzazione prodotti, prezzi, creazione delle offerte'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: false },
  },
  {
    name: _t('Conferma di ordini'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: false },
  },
  {
    name: _t('Conferma di upgrade'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: false },
  },
  {
    name: _t('Rinnovi/Disdette di servizi'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Attivazione/Disattivazione di pagamenti ricorrenti'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Visualizzazione e pagamento fatture'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Visualizzazione delle password dei servizi'),
    grant: { admin: true, amministrativi: false, commerciali: false, tecnici: true },
  },
  {
    name: _t('Modifica delle zone DNS'),
    grant: { admin: true, amministrativi: false, commerciali: false, tecnici: true },
  },
  {
    name: _t('Apertura ticket'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: true },
  },
];

const resellerGrants: Grant[] = [
  {
    name: _t('Visualizzazione clienti'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: true },
  },
  {
    name: _t('Possibilità di richiedere accesso ai clienti'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: true },
  },
  {
    name: _t('Creazione nuovo prospect'),
    grant: { admin: true, amministrativi: true, commerciali: true, tecnici: false },
  },
  {
    name: _t('Visualizzazione credito Artera e gestione delle provvigioni'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
  {
    name: _t('Aggiornare le skill'),
    grant: { admin: true, amministrativi: true, commerciali: false, tecnici: false },
  },
];
</script>
